import moment from 'moment'
import React, { useState } from 'react'
import { Pie, Bar } from 'react-chartjs-2'
import { Card, Col, Row, Statistic, Tabs } from 'antd'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js'
import DateRangePicker from '../../../components/reusable/rangePicker'
import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai'

const { TabPane } = Tabs

ChartJS.register(ArcElement, CategoryScale, Tooltip, Legend, BarElement, Title, LinearScale)

const Patients = () => {
    const [days, setDays] = useState(moment().days())
    const [range, setRange] = useState([moment().startOf('day'), moment().endOf('day')])

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top'
            },
            title: {
                display: true,
                text: 'Visits By Age Group'
            }
        },
    }

    const pData = {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
        datasets: [
            {
                label: '# of Votes',
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                ],
                borderWidth: 1,
            },
        ],
    }

    const bData = {
        labels: ['< 5 years', '5 - 10 years', '10 - 18 years', '18 - 35 years', '> 35 years'],
        datasets: [
            {
                label: 'New',
                data: [12, 19, 3, 5, 2],
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'Revisits',
                data: [19, 3, 5, 2, 34],
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
            {
                label: 'Total',
                data: [31, 22, 8, 7, 36],
                backgroundColor: 'rgba(53, 132, 215, 0.5)',
            }
        ],
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto h-full overflow-hidden">
            <DateRangePicker ranges={range} selectRange={setRange} showTime />
            <div className="w-1/3 mx-2 my-3">
                <h2 className='text-xl font-semibold'>Visits By Status</h2>
                <Row gutter={16}>
                    <Col span={12}>
                        <Card bordered={false}>
                            <Statistic
                                title="New Visits"
                                value={11.28}
                                precision={2}
                                valueStyle={{
                                    color: '#3f8600',
                                }}
                                prefix={<AiOutlineArrowDown />}
                                suffix="%" />
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card bordered={false}>
                            <Statistic
                                title="Revisits"
                                value={11.28}
                                precision={2}
                                valueStyle={{
                                    color: '#cf1322',
                                }}
                                prefix={<AiOutlineArrowUp />}
                                suffix="%" />
                        </Card>
                    </Col>
                </Row>
            </div>
            <div className="w-full overflow-y-scroll h-full">
                <Tabs className="min-h-full w-full">
                    <TabPane key="0" tab="Graphical">
                        <div className="flex py-10 font-semibold text-md justify-center">
                            <div className="w-1/3">
                                <h2 className='text-xl font-semibold'>Queued Clinic Visits</h2>
                                <Pie data={pData} />
                            </div>
                            <div className="w-2/3">
                                <h2 className='text-xl font-semibold'>Visits By Age Group</h2>
                                <Bar options={options} data={bData} />
                            </div>
                        </div>
                    </TabPane>
                    <TabPane key="1" tab="Summary">
                        <table className="table-auto w-full mt-2">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Clinic</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Under 5 Male</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Under 5 Female</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Over 5 Male</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Over 5 Female</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Over 60 Male</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Over 60 Female</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">New Visits</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Revisits</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Total</div>
                                    </th>
                                </tr>
                            </thead>
                            {/* Table body */}
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {/* Row */}
                                {
                                    Array(days).fill().map((day, key) =>
                                        <tr>
                                            <td className="p-2">
                                                <div className="text-center">ENT Consultation</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">New Visits: 100</div>
                                                <div className="">Revisits: 100</div>
                                                <div className="">Total: 100</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">New Visits: 100</div>
                                                <div className="">Revisits: 100</div>
                                                <div className="">Total: 100</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">New Visits: 100</div>
                                                <div className="">Revisits: 100</div>
                                                <div className="">Total: 100</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">New Visits: 100</div>
                                                <div className="">Revisits: 100</div>
                                                <div className="">Total: 100</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">New Visits: 100</div>
                                                <div className="">Revisits: 100</div>
                                                <div className="">Total: 100</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">New Visits: 100</div>
                                                <div className="">Revisits: 100</div>
                                                <div className="">Total: 100</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">Male: 100</div>
                                                <div className="">Female: 100</div>
                                                <div className="">Total: 100</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">Male: 100</div>
                                                <div className="">Female: 100</div>
                                                <div className="">Total: 100</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="">Male: 100</div>
                                                <div className="">Female: 100</div>
                                                <div className="">Total: 100</div>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </TabPane>
                </Tabs>
            </div>
        </div>
    )
}

export default Patients